import React from "react";

interface StatusBadgeProps {
  status: string;
  type?: "request" | "attendance";
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, type = "attendance" }) => {
  if (type === "request") {
    const formattedStatus = (status || "PENDING").toUpperCase();
    let statusClasses = "text-amber-600 border-amber-200 bg-amber-50";
    if (formattedStatus === "APPROVED") {
      statusClasses = "text-green-600 border-green-200 bg-green-50";
    } else if (formattedStatus === "REJECTED") {
      statusClasses = "text-red-600 border-red-200 bg-red-50";
    } else if (formattedStatus === "PENDING") {
      statusClasses = "text-blue-600 border-blue-200 bg-blue-50";
    }

    return (
      <span className={`inline-flex items-center px-2 py-0.5 text-[10px] font-semibold border rounded-full uppercase ${statusClasses}`}>
        {formattedStatus}
      </span>
    );
  }

  // Attendance type
  const formattedStatus = (status || "PRESENT").toLowerCase();
  let statusClasses = "text-amber-600 border-amber-600 bg-amber-50";
  if (formattedStatus === "present") {
    statusClasses = "text-green-600 border-green-600 bg-green-50";
  } else if (formattedStatus === "absent") {
    statusClasses = "text-destructive border-destructive bg-destructive/10";
  } else if (formattedStatus === "leave") {
    statusClasses = "text-blue-600 border-blue-600 bg-blue-50";
  } else if (formattedStatus === "late") {
    statusClasses = "text-orange-600 border-orange-600 bg-orange-50";
  }

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 text-xs font-semibold border rounded-full capitalize ${statusClasses}`}>
      {formattedStatus}
    </span>
  );
};

export default StatusBadge;
